<template>  
  <div class="p-1 hover:text-gray-600 hover:cursor-pointer" :class="{'upload-btn-disabled': disabled}" @click="$refs.file.click()">
    <input type="file" ref="file" id="fff" style="display: none" @change="onClick()" :accept="accept" />
    <font-awesome-icon :icon="icon" /><slot />
  </div>  
</template>

<script>
export default {
  name: "LUpload",
  props: ["icon", "disabled", "accept"],
  methods: {
    onClick() {
      this.$emit("on-click", this.$refs.file.files[0]);
      this.$refs.file.type = "text";
      this.$refs.file.type = "file";
    }
  }
};
</script>


<style lang="postcss" scoped>
.upload-btn-disabled {
  @apply text-gray-400;
  pointer-events: none;
}
</style>

